import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Home, PageNotFound } from './pages';
import { Footer, Navbar } from './components';
import { RootState } from './reducers/store';

const App = () => {
  const { modeValue: theme } = useSelector((state: RootState) => state?.modeList);

  return (
    <div className='main-container' id={theme}>
      <Toaster position='top-center' reverseOrder={false} gutter={8} toastOptions={{ className: 'toast-option' }} containerStyle={{top: '15%', }}></Toaster>
        <Navbar theme={theme} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/page-not-found' element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
      <Footer />
    </div>
  )
}

export default App